import { QueryHookOptions } from '@apollo/client';
import { useQuery } from '@ts-gql/apollo';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import React from 'react';

export const GET_USER_TEMPLATE_LIST_QUERY = gql`
  query GetTemplateList {
    getTemplateList {
      cloudId
      name
      description
      wfCreatedBy
      wfCreatedOnUTC
      wfDeletedOnUTC
      entities
    }
  }
` as import('../../__generated__/ts-gql/GetTemplateList').type;

export type GetTemplateListQueryVariables = OperationVariables<
  typeof GET_USER_TEMPLATE_LIST_QUERY
>;
export type GetTemplateListQueryResult = OperationData<
  typeof GET_USER_TEMPLATE_LIST_QUERY
>;
export type GetTemplateListResult = NonNullable<
  GetTemplateListQueryResult['getTemplateList']
>[number];

export const useGetTemplateList = (
  options?: QueryHookOptions<GetTemplateListQueryResult>
) => {
  const res = useQuery(GET_USER_TEMPLATE_LIST_QUERY, {
    context: { service: 'templates' },
    ...options,
  });

  return React.useMemo(
    () => ({ ...res, data: res.data?.getTemplateList }),
    [res]
  );
};
